import { Card, Typography, CardProps } from '@mui/material'

type PersonCardProps = CardProps & {
  name: string
}

export function PersonCard({ name, children, ...props }: PersonCardProps) {
  return (
    <Card {...props} sx={{ cursor: 'pointer' }}>
      <Typography variant="h4" mb={1}>
        {name}
      </Typography>

      {children}
    </Card>
  )
}
